import { Stack, Button } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { InvitedOrganizationsTable } from './invited-organizations-table'
import { DialogInviteOrganization } from './dialog-invite-organization'
import { useBoolean } from 'hooks/useBoolean'

type Props = {
  tenderId: string
  isDisabled?: boolean
}

export const TenderInvitationSection = ({ tenderId, isDisabled = false }: Props) => {
  const { t } = useTranslation()
  const dialogInviteOrganization = useBoolean(false)

  return (
    <>
      {dialogInviteOrganization.isTrue && (
        <DialogInviteOrganization
          tenderId={tenderId}
          isOpen
          onClose={dialogInviteOrganization.setFalse}
        />
      )}
      <Stack spacing={1}>
        {!isDisabled && (
          <Stack direction="row" justifyContent="flex-end">
            <Button
              onClick={dialogInviteOrganization.setTrue}
              variant="contained"
              style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            >
              {t('invite')}
            </Button>
          </Stack>
        )}

        <InvitedOrganizationsTable tenderId={tenderId} />
      </Stack>
    </>
  )
}
